import { DatasetItem } from '../../../types/types';
import {
  ReportItemGroup,
  ReportItemsDataRow,
  ReportPageSetup,
} from '../types';
import ReportItemsTable from './ReportItemsTable';
import { useTranslate } from '../../../hooks/context/useTranslate';

interface ReportItemsGroupsProps {
  dataRows: ReportItemsDataRow[];
  itemsBySource: Record<string, DatasetItem[]>;
  groups: ReportItemGroup[];
  page: ReportPageSetup;
  showEmptyNotice?: boolean;
}

/**
 * One primary table row plus zero or more subordinate table bands per master
 * record. The wrapper is the atomic pagination unit, so allergens or recipe
 * rows never drift to another product merely because a page ended.
 */
const ReportItemsGroups = ({
  dataRows,
  itemsBySource,
  groups,
  page,
  showEmptyNotice = true,
}: ReportItemsGroupsProps) => {
  const { t } = useTranslate();
  const primary = dataRows[0];
  if (!primary) return null;

  return (
    <section className="report-section report-section-items">
      <div className="report-items-primary-heading">
        <ReportItemsTable
          section={primary}
          items={itemsBySource[primary.source] ?? []}
          rows={[]}
          page={page}
          showEmptyNotice={false}
        />
      </div>

      <div className="report-item-groups">
        {groups.map((group) => (
          <div className="report-item-group" key={group.masterRowId}>
            {dataRows.map((dataRow, dataRowIndex) => (
              <ReportItemsTable
                key={`${dataRow.source}:${dataRowIndex}`}
                section={
                  dataRowIndex === 0
                    ? { ...dataRow, repeatHeaderOnEachPage: false }
                    : dataRow
                }
                items={itemsBySource[dataRow.source] ?? []}
                rows={group.rowsBySource[dataRow.source] ?? []}
                page={page}
                showEmptyNotice={false}
              />
            ))}
          </div>
        ))}
      </div>

      {groups.length === 0 && showEmptyNotice && (
        <p className="report-empty">{t('print.noData')}</p>
      )}
    </section>
  );
};

export default ReportItemsGroups;
